import React from "react";
import {
  Icon,
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
  useColorModeValue,
  IconButton,
} from "@chakra-ui/react";
import {
  MdOutlineMoreHoriz,
  MdEdit,
  MdDelete,
  MdPerson,
  MdLock,
  MdLockOpen,
} from "react-icons/md";

export default function UserTableActionsMenu({ row, onEdit, onDelete, onToggleStatus }) {
  const textColor = useColorModeValue("secondaryGray.500", "white");
  const textHover = useColorModeValue(
    { color: "secondaryGray.900", bg: "unset" },
    { color: "secondaryGray.500", bg: "unset" }
  );
  const iconColor = useColorModeValue("brand.500", "white");
  const bgList = useColorModeValue("white", "whiteAlpha.100");
  const bgShadow = useColorModeValue(
    "14px 17px 40px 4px rgba(9, 129, 248, 0.08)",
    "unset"
  );
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Menu isOpen={isOpen} onClose={onClose}>
      <MenuButton
        as={IconButton}
        aria-label="Actions"
        icon={<Icon as={MdOutlineMoreHoriz} color={iconColor} w='20px' h='20px' />}
        bg={bgButton}
        _hover={bgHover}
        _focus={bgFocus}
        _active={bgFocus}
        w='32px'
        h='32px'
        minW='32px'
        onClick={onOpen}
        borderRadius='10px'
        size="sm"
      />
      <MenuList
        w='150px'
        minW='unset'
        maxW='180px !important'
        border='transparent'
        backdropFilter='blur(63px)'
        bg={bgList}
        boxShadow={bgShadow}
        borderRadius='20px'
        p='15px'>
        <MenuItem
          transition='0.2s linear'
          color={textColor}
          _hover={textHover}
          p='0px'
          borderRadius='8px'
          _active={{
            bg: "transparent",
          }}
          _focus={{
            bg: "transparent",
          }}
          mb='10px'
          onClick={() => {
            onEdit(row);
            onClose();
          }}>
          <Flex align='center'>
            <Icon as={MdEdit} h='16px' w='16px' me='8px' />
            <Text fontSize='sm' fontWeight='400'>
              Edit
            </Text>
          </Flex>
        </MenuItem>
        
        {onToggleStatus && (
          <MenuItem
            transition='0.2s linear'
            color={textColor}
            _hover={textHover}
            p='0px'
            borderRadius='8px'
            _active={{
              bg: "transparent",
            }}
            _focus={{
              bg: "transparent",
            }}
            mb='10px'
            onClick={() => {
              onToggleStatus(row);
              onClose();
            }}>
            <Flex align='center'>
              <Icon as={row.isActive ? MdLock : MdLockOpen} h='16px' w='16px' me='8px' />
              <Text fontSize='sm' fontWeight='400'>
                {row.isActive ? 'Deactivate' : 'Activate'}
              </Text>
            </Flex>
          </MenuItem>
        )}
        
        <MenuItem
          transition='0.2s linear'
          color='red.500'
          _hover={{ color: 'red.600', bg: 'red.50' }}
          p='0px'
          borderRadius='8px'
          _active={{
            bg: "transparent",
          }}
          _focus={{
            bg: "transparent",
          }}
          onClick={() => {
            onDelete(row.id);
            onClose();
          }}>
          <Flex align='center'>
            <Icon as={MdDelete} h='16px' w='16px' me='8px' />
            <Text fontSize='sm' fontWeight='400'>
              Delete
            </Text>
          </Flex>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}